import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Search from "./search";

export default () => (
  <StaticQuery<GatsbyTypes.Query>
    query={graphql`
      query {
        allShopifyProduct {
          edges {
            node {
              id
              title
              tags
              handle
              createdAt
              shopifyId
              availableForSale
              variants {
                id
                price
                priceV2 {
                  amount
                  currencyCode
                }
                shopifyId
                availableForSale
              }
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 320) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={({ allShopifyProduct }) => {
      return <Search allShopifyProduct={allShopifyProduct} />;
    }}
  />
);
